import {
  Component,
  Inject,
  PLATFORM_ID,
  Renderer2,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  AppSharedService,
  checkCrdlWithRetry,
  getContext,
} from '@nx-averycom/shared/utils';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd, Event as RouterEvent } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'nx-averycom-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'main';
  themeMode: string;
  subscriptions: Subscription[] = [];
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private appService: AppSharedService,
    private renderer: Renderer2,
    private router: Router
  ) {}
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.subscriptions = [
        this.averyThemeModeSubscription(),
        this.routerEventsSubscription(),
      ];
    }
  }
  /**
   * Checks for route change and if it is NavigationEnd, performs functions below.
   * @returns {Subscription}
   * @memberof AppComponent
   */
  routerEventsSubscription(): Subscription {
    return this.router.events
      .pipe(filter((event: RouterEvent) => event instanceof NavigationEnd))
      .subscribe((event: RouterEvent) => {
        const navigationEndEvent = event as NavigationEnd;
        const route = navigationEndEvent.url.split('?')[0];
        const fullPath = `${environment.domain}${route}`;
        // [Cordial] Emit cordial events on every page
        checkCrdlWithRetry(fullPath);
        // [DY] Recommendation Context, this will help DY detect page changes
        window.DY = window.DY || {};
        if (DY !== undefined) {
          DY.recommendationContext = getContext();
        }
      });
  }

  /**
   * Returns subscription that handles theme mode.
   *
   * @returns {Subscription}
   * @memberof AppComponent
   */
  averyThemeModeSubscription(): Subscription {
    return this.appService.themeMode
      .pipe(filter((type: string) => this.themeMode !== type))
      .subscribe((type: string) => {
        if (type !== '') {
          this.themeMode = type;
          const bodyElement = document.getElementsByTagName('body')[0];

          // Set class to current theme (as long as it is not 'default')
          if (type !== 'default') {
            this.renderer.setAttribute(bodyElement, 'data-avry-mode', type);
            // Else remove data attribute
          } else {
            this.renderer.removeAttribute(bodyElement, 'data-avry-mode');
          }
        } else {
          // Initial theme mode check on this subscription init, if no type is configured yet
          this.appService.setThemeMode();
        }
      });
  }
}
